import DataFetch from '../../Utility/data-fetch'
import {default as Storage} from '../../Utility/site-cookies'

const call = (translationsUrl, booksUrl, chaptersUrl) => {
    return {
        STATES: Object.freeze({
            TRANSLATION: 1,
            BOOK: 2,
            CHAPTER: 3
        }),

        loading: false,

        selectedTranslation: null,
        selectedBook: null,

        state: null,

        translations: [],
        immediateResults: [],

        Init() {
            this.loading = true
            this.state = this.STATES.TRANSLATION;
            const version = Storage().readPref("translation")
            const userTranslation = version ? 'niv' : version

            DataFetch.get(translationsUrl, {translationCode: userTranslation})
                .then(r => {
                    this.translations = r.data.translations
                    this.SelectTranslation(this.translations.find(t => t.code === userTranslation))
                    this.loading = false
                })
                .catch(e => {
                    console.log(e)
                    this.loading = false
                })
        },
        ClearSelected() {
            this.loading = true
            this.state = this.STATES.TRANSLATION
            this.selectedTranslation = null
            this.selectedBook = null
            this.loading = false
        },
        SelectTranslation(translation) {
            this.loading = true
            Storage().writePref('translation', translation.code);
            this.selectedTranslation = translation
            this.selectedBook = null
            this.state = this.STATES.BOOK
            DataFetch.get(booksUrl + `?translationCode=${this.selectedTranslation.code}`)
                .then(r => {
                    this.immediateResults = r.data
                    this.loading = false
                })
                .catch(e => {
                    console.log(e)
                    this.loading = false
                })
        },
        SelectBook(book) {
            this.loading = true
            this.selectedBook = book
            this.state = this.STATES.CHAPTER
            DataFetch.get(chaptersUrl + `?translationCode=${this.selectedTranslation.code}&bookSlug=${this.selectedBook.slug}&chapterId=1`)
                .then(r => {
                    this.immediateResults = r.data.chapters
                    this.loading = false
                })
                .catch(e => {
                    console.log(e)
                    this.loading = false
                })
        },
    }
}

export default call